/* eslint-disable no-cond-assign */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, OnInit, Output, EventEmitter, Input, forwardRef, AfterViewInit, AfterViewChecked } from '@angular/core';
import { ISystemOption } from 'src/app/models/ticket/system-option.interface';
import { TicketBase } from '../ticket-base';
import { TicketService } from 'src/app/services/ticket.service';
import { UserService } from 'src/app/services/user.service';
import { NotificationService } from 'src/app/services/notification.service';
import { BonusService } from 'src/app/services/bonus.service';
import { UtilityService } from 'src/app/services/util/utility.service';
import { FreeBetService } from 'src/app/services/freeBet.service';
import { ModelMapperService } from 'src/app/services/util/model.mapper.service';
import { TicketProviderService } from 'src/app/services/providers/ticket.provider.service';
import { TicketType, FreeBetProcessingType, ErrorLevel, EventMappingType, TypeOfPlaceBetTicket } from 'src/app/models/enums';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { ITicketItemGroup } from 'src/app/models/ticket/ticketItemGroup.interface';
import { ConstantValues } from 'src/app/models/util/constantValues';
import { ICustomNotification } from 'src/app/models/notification/customNotification.interface';
import * as Combinatorics from 'js-combinatorics';
import { IOddContainer } from '../oddContainer.interface';
import { ITicket } from 'src/app/models/ticket/ticket.interface';
import { ITicketGroup } from 'src/app/models/ticket/ticketGroup.interface';
import { StorageService } from 'src/app/services/util/storage.service';
import { ITicketData } from 'src/app/models/ticket/ticketData.interface';
import { SettingsService } from 'src/app/services/settings.service';
import { ViewConfigurations } from 'src/app/models/util/viewConfigurations';
import { DeployParams } from 'src/app/deployParams';
import { AuthenticationService } from 'src/app/ticket-manager/services/authentication.service';
import { environment } from 'src/environments/environment';
declare let jQuery: any;

@Component({
  selector: 'app-ticket-system',
  templateUrl: './ticket-system.component.html',
  styleUrls: ['./ticket-system.component.less'],
  providers: [{ provide: TicketBase, useExisting: forwardRef(() => TicketSystemComponent) }]
})

export class TicketSystemComponent extends TicketBase implements AfterViewInit {
  public CV;
  // private _isBankersEnabled = true;
  private systemTicketItemGroups: ITicketItemGroup[] = [];
  public bankerTicketItemGroups: ITicketItemGroup[] = [];
  protected language: string;
  protected wagerPerBetInputField: HTMLInputElement;


  private isTicketLive: boolean;

  @Output()
  bankersEnabledChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output()
  resetSelectedEventsInCombinations: EventEmitter<void> = new EventEmitter<void>();


  @Input()
  set selectedEventsInCombinations(selectedCombinations: number[]) {
    if (selectedCombinations && selectedCombinations.length > 0){
      for (const sysOpt of this.systemOptions) {
        if (selectedCombinations.includes(sysOpt.eventsInCombination)) {
          this.checkbox(sysOpt);
        }
      }
    }
    setTimeout(() => {
      this.resetSelectedEventsInCombinations.emit();
    });
  }




  // Holds the systems options and whether they are selected or not

  systemOptions: ISystemOption[] = [];

  isMultiplayBanker = false;
  isMultiplaySystem = false;


  private isCreate = true;
  isUserLoggedIn = false;


  constructor(
    ticketService: TicketService,
    userService: UserService,
    notificationService: NotificationService,
    bonusService: BonusService,
    utilityService: UtilityService,
    public freeBetService: FreeBetService,
    modelMapper: ModelMapperService,
    storage: StorageService,
    settingsService: SettingsService,
    authentificationService: AuthenticationService) {
    super(ticketService, userService, notificationService, bonusService, utilityService, freeBetService, modelMapper, storage, settingsService, authentificationService);
    if (this.userService.user.userSBToken || environment.localDeploy || (this.authentificationService.loggedAffiliate && storage.affiliateJwtToken)) {
      this.isUserLoggedIn = true;
    }

  }
  ngAfterViewInit(): void {
    this.payinInputField = document.getElementById('totalStakeInput') as HTMLInputElement;
  }

  set stakePerBet(val: any) {
    // const value = +this.wagerPerBetInputToNumber(val, this.ticketData.numberOfBets);
    this.payin = (+val * this.ticketData.numberOfBets).toFixed(4);
  }

  // protected wagerPerBetInputToNumber(value: string, numberOfBets: number): string {
  //   if (!value) {
  //     return '0';
  //   }
  //   value = value.toString();
  //   let editedVal = value.replace(',', '.');
  //   // console.log('eVal ,to . : ' + editedVal);
  //   // console.log('eVal numberonly: ' + editedVal);
  //   editedVal = editedVal.replace('..', '.');
  //   // console.log('eVal .. to .: ' + editedVal);
  //   const lastInd = editedVal.lastIndexOf('.');
  //   const firstInd = editedVal.indexOf('.');
  //   if (firstInd === 0) {
  //     editedVal = editedVal.slice(0, firstInd);
  //   }
  //   if (firstInd !== lastInd) {
  //     if (lastInd > -1) {
  //       editedVal = editedVal.slice(0, value.length - 1);
  //     }
  //   }
  //   if (+editedVal * numberOfBets >= ConstantValues.MAX_STAKE) {
  //       editedVal = (ConstantValues.MAX_STAKE / numberOfBets).toFixed(2);
  //   }
  //   value = editedVal;
  //   if (!this.wagerPerBetInputField) {
  //     this.wagerPerBetInputField = document.getElementById('wagerPerBetInputField') as HTMLInputElement;
  //   }
  //   if (this.wagerPerBetInputField) {
  //     this.wagerPerBetInputField.value = value;
  //   }
  //   // console.log('eVal .. to .: ' + editedVal);
  //   return value;
  // }

  focusWagerInput() {
    const wagerInput = jQuery('#wagerPerBetInputField');
    if (!this.isMobileView) {
      wagerInput.select();
      wagerInput[0].select();
    }
  }

  protected onTicketChanged(changed: boolean) {
    if (this.isOddChanged) {
      for (const sysOpt of this.systemOptions) {
        if (!sysOpt.optionSelected) {
          sysOpt.maxOdds = 0;
        }
      }
    }

    const selectedSystemOptions = this.systemOptions.filter(so => so.optionSelected);
    if (this.isOddChanged && !this.isCreate && this.systemOptions.length > 0 && selectedSystemOptions.length > 0) {
      this.isTicketLive = this.systemTicketItemGroups.findIndex(gr => gr.isLive) > -1 || this.bankerTicketItemGroups.findIndex(gr => gr.isLive) > -1;
      this.ticketService.updateOddsSystemOptions(
        selectedSystemOptions,
        this.orderingForTicketItemGroups,
        this.systemTicketItemGroups,
        this.bankerTicketItemGroups,
        this.oddsMap,
        this.minOddsMap,
        this.isTicketLive,
        this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers,
        this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers);
      const td = this.ticketService.calculateOddsAndWinningsForUpdatedSystemOptions(
        selectedSystemOptions,
        this.freeBetService.playerFreeBetSettings,
        this.bonusService.playerBonussSettings,
        this.bonusService.bonussSettings,
        this.freeBetBalance,
        selectedSystemOptions.findIndex((so) => so.eventsInCombination < this.systemTicketItemGroups.length) < 0,
        this.orderingForTicketItemGroups,
        this.wagerPerBet,
        this.ticketData.totalStake,
        this.ticketData.numberOfBets,
        this.ticketData.payin,
        this.ticketData.taxBeforeStake,
        !this.isTicketLive && ViewConfigurations.showNumberOfHitsForTicketSystem);

      this.ticketData.totalWinings = td.totalWinings;
      this.ticketData.minWinings = td.minWinings;
      this.ticketData.totalOdd = td.totalOdd;
      this.ticketData.minOdd = td.minOdd;
      this.ticketData.possibleWin = td.possibleWin;
      this.ticketData.bonus = td.bonus;
      this.ticketData.bonusPercent = td.bonusPercent;
      this.ticketData.freeBetValue = td.freeBetValue;
      this.ticketData.freeBetValueToShow = td.freeBetValueToShow;
      this.ticketData.taxOnWinings = td.taxOnWinings;
      this.ticketData.possibleWinWithoutTax = td.possibleWinWithoutTax;
      this.ticketData.possibleMinPayout = td.possibleMinPayout;
      this.ticketData.taxOnMinWinning = td.taxOnMinWinning;
      this.ticketData.possibleWinForNumberOfHits = td.possibleWinForNumberOfHits;
    } else {
      this.resetCalculatedValues();
      this.resetSystemOptions();
    }
    this.isCreate = false;
    this.ticketService.updateTicketData(this.ticketData);
  }

  isTicketLimitationsFulfiled(sysOpt: ISystemOption): boolean {
    const error: ICustomNotification = {

    } as ICustomNotification;

    if (this.ticketData.numberOfBets + sysOpt.numberOfCombinations > ConstantValues.MAX_COMBINATIONS && !sysOpt.optionSelected) {
      const error: ICustomNotification = {
        errorLevel: ErrorLevel.Notification,
        title: DynamicTranslations.maxCombinationsWhenSelectingSystem_Error_title,
        message: DynamicTranslations.maxCombinationsWhenSelectingSystem_Error_errorMessage,
      } as ICustomNotification;
      this.sendNotification(error);
      return true;
    }
    return false;
  }

  // Updates the max odds and winings based on the selected system combinations.
  checkbox(sysOpt: ISystemOption) {
    if (!this.isTicketLimitationsFulfiled(sysOpt)) {
      sysOpt.optionSelected = !sysOpt.optionSelected;
      if (sysOpt.maxOdds === 0) {
        if (Object.keys(this.bankerTicketItemGroups).length > 0) {
          this.ticketService.calculateBankerSystemOdds(
            sysOpt,
            this.systemTicketItemGroups,
            this.bankerTicketItemGroups,
            this.oddsMap,
            this.minOddsMap,
            !this.isTicketLive && ViewConfigurations.showNumberOfHitsForTicketSystem,
            this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers,
            this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers);
        } else {
          this.ticketService.calculateRegularSystemOdds(
            sysOpt,
            this.systemTicketItemGroups,
            this.orderingForTicketItemGroups,
            this.oddsMap,
            this.minOddsMap,
            !this.isTicketLive && ViewConfigurations.showNumberOfHitsForTicketSystem,
            this.ticketService.maxOddsSysEvIdsByOddHighToLowWithoutBankers,
            this.ticketService.minOddsSysEvIdsByOddLowToHighWithoutBankers);
        }
      }

      // const multiplier = sysOpt.optionSelected ? 1 : -1;
      // this.ticketData.numberOfBets += (multiplier * sysOpt.numberOfCombinations);
      // this.ticketData.totalOdd += (multiplier * sysOpt.maxOdds);

      this.ticketData.minOdd = 1;

      // next two added sa fix of extremely big odd
      this.ticketData.numberOfBets = 0;
      this.ticketData.totalOdd = 0;
      this.ticketData.oddsForNumberOfHits = {};
      this.systemOptions.forEach(so => {
        if (so.optionSelected) {
          // next two added sa fix of extremely big odd
          this.ticketData.numberOfBets += so.numberOfCombinations;
          this.ticketData.totalOdd += so.maxOdds;

          if (this.ticketData.minOdd === 1) {
            this.ticketData.minOdd = so.minOdds;
          } else if (this.ticketData.minOdd >= so.minOdds) {
            this.ticketData.minOdd = so.minOdds;
          }

          if (ViewConfigurations.showNumberOfHitsForTicketSystem && !this.isTicketLive) {
            const keys = Object.keys(so.oddsForNumberOfHits);
            for (const key of keys) {
              if (!this.ticketData.oddsForNumberOfHits[+key]) {
                this.ticketData.oddsForNumberOfHits[+key] = { maxOdds: 0, minOdds: 0 };
              }
              this.ticketData.oddsForNumberOfHits[+key].maxOdds = this.ticketData.oddsForNumberOfHits[+key].maxOdds + so.oddsForNumberOfHits[key].maxOdds;
              this.ticketData.oddsForNumberOfHits[+key].minOdds += so.oddsForNumberOfHits[key].minOdds;

            }
          }
        }
      });

      this.mobileTotalOdd.emit(this.ticketData.totalOdd);

      this.calculateOddAndWinings();
    }
    this.ticketService.updateTicketData(this.ticketData);

  }


  private resetCalculatedValues() {
    this.ticketData.possibleWin = 0;
    this.ticketData.numberOfBets = 0;
    this.ticketData.totalWinings = 0;
    this.ticketData.totalOdd = 0;
    this.ticketData.minOdd = 0;
    this.ticketData.minWinings = 0;
    this.ticketData.bonus = 0;
    this.ticketData.bonusPercent = 0;
    this.ticketData.freeBetValue = 0;
    this.ticketData.taxOnWinings = 0;
    this.ticketData.possibleWinWithoutTax = 0;
    this.ticketData.possibleMinPayout = 0;
    this.ticketData.taxOnMinWinning = 0;
    this.ticketData.possibleWinForNumberOfHits = [];
    this.mobileTotalOdd.emit(this.ticketData.totalOdd);
    this.isMultiplaySystem = false;
    this.isMultiplayBanker = false;
  }

  protected calculateOddAndWinings() {
    this.ticketService.calculateOddAndWiningsTicketSystem(
      this.ticketData,
      this.wagerPerBet,
      this.freeBetService.playerFreeBetSettings,
      this.bonusService.playerBonussSettings,
      this.bonusService.bonussSettings,
      this.freeBetBalance,
      this.systemOptions.findIndex((so) => so.optionSelected && so.eventsInCombination < this.systemTicketItemGroups.length) < 0,
      this.orderingForTicketItemGroups,
      this.ticketData.totalStake);
    if (!this.ticketData.freeBetValue || this.ticketData.freeBetValue === 0) {
      this.placeBetType = (this.isUserLoggedIn && this.accountBalance >= this.ticketData.totalStake) ? TypeOfPlaceBetTicket.Standard : TypeOfPlaceBetTicket.Express;
    }
  }


  private resetSystemOptions() {

    this.systemOptions = [];
    this.bankerTicketItemGroups = [];
    this.systemTicketItemGroups = [];
    // bankers are always enabled
    // if (this.isBankersEnabled) {
    for (const order of this.orderingForTicketItemGroups) {
      if (!this.ticketItemGroups[order.eventId].isInBankersGroup) {
        if (order.outcomeIds.length !== 1) {
          if (!this.isMultiplaySystem) {
            this.isMultiplaySystem = true;
          }
        }
        this.systemTicketItemGroups.push(this.ticketItemGroups[order.eventId]);
      }
      else {
        if (order.outcomeIds.length !== 1) {
          if (!this.isMultiplayBanker) {
            this.isMultiplayBanker = true;
          }
        }
        this.bankerTicketItemGroups.push(this.ticketItemGroups[order.eventId]);
      }

    }

    this.isTicketLive = this.systemTicketItemGroups.findIndex(gr => gr.isLive) > -1 || this.bankerTicketItemGroups.findIndex(gr => gr.isLive) > -1;
    // In this case the systema behaves as this is a regular system since there are no banker events
    if (this.bankerTicketItemGroups.length === 0) {
      this.systemOptions =  this.ticketService.calculateRegularSystemOptions(this.ticketItemGroups, this.orderingForTicketItemGroups, this.isMultiplaySystem, this.systemTicketItemGroups, this.bankerTicketItemGroups);
      // return;
    } else if (this.systemTicketItemGroups.length !== 0) {
      this.systemOptions = this.ticketService.calculateMultiSystemOptions(this.isMultiplaySystem, this.isMultiplayBanker, this.systemTicketItemGroups, this.bankerTicketItemGroups);
        // for (let i = 0; i < this.systemTicketItemGroups.length; i++) {
        //   if (this.isMultiplayBanker || this.isMultiplaySystem) {
        //     this.systemOptions.push({
        //       eventsInCombination: i + 1,
        //       maxOdds: 0,
        //       minOdds: 0,
        //       numberOfCombinations: this.calcNumOfCombination(this.systemTicketItemGroups, i + 1) * this.calcNumOfCombination(this.bankerTicketItemGroups, this.bankerTicketItemGroups.length),
        //       optionSelected: false,
        //       totalNumberOfEvents: this.systemTicketItemGroups.length,
        //       isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1),
        //       oddsForNumberOfHits: {}
        //     });
        //   } else {
        //     this.systemOptions.push({
        //       eventsInCombination: i + 1,
        //       maxOdds: 0,
        //       minOdds: 0,
        //       numberOfCombinations: Math.round(Combinatorics.C(this.systemTicketItemGroups.length, i + 1)) * Math.round(Combinatorics.C(this.bankerTicketItemGroups.length, this.bankerTicketItemGroups.length)),
        //       optionSelected: false,
        //       totalNumberOfEvents: this.systemTicketItemGroups.length,
        //       isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1),
        //       oddsForNumberOfHits: {}
        //     });
        //   }
        // }
      } else {
        if (this.isMultiplayBanker) {
          this.ticketData.numberOfBets = this.ticketService.calcNumOfCombination(this.bankerTicketItemGroups, this.bankerTicketItemGroups.length);
        } else {
          this.ticketData.numberOfBets = Math.round(Combinatorics.C(this.bankerTicketItemGroups.length, this.bankerTicketItemGroups.length));
        }
        const bankerOdd: IOddContainer = this.ticketService.calculateBankerOdds(this.bankerTicketItemGroups, this.oddsMap, this.minOddsMap);
        this.ticketData.totalOdd = bankerOdd.maxOdd;
        this.ticketData.minOdd = bankerOdd.minOdd;
        this.mobileTotalOdd.emit(this.ticketData.totalOdd);
        this.calculateOddAndWinings();
      }


    // if (this.systemOptions.filter(s => s.isSuperBetConditionFulfilled).length > 0 || this.systemOptions.length === 0) {
    //   if(this.super)
    //   this.showSuperBetMsg = false;
    // } else {
    //   this.showSuperBetMsg = true;
    // }

    if (ViewConfigurations.showOnlySystemTicket) {
      if (!this.isOddChanged && (this.systemOptions.length > 0 && this.systemOptions.filter(s => s.optionSelected).length === 0)) {
        this.checkbox(this.systemOptions[this.systemOptions.length - 1]);
      }
    } else {
      if (!this.isOddChanged && (this.isMobileView && this.systemOptions.length > 0 && this.systemOptions.filter(s => s.optionSelected).length === 0)) {
        this.checkbox(this.systemOptions[this.systemOptions.length - 1]);
      }
    }
  }

  isSystemOptionSuperBetConditionFulfilled(eventsInCombination: number): boolean {
    const systemSuperBetEventsCount = this.systemTicketItemGroups.filter(g => g.mappingType === EventMappingType.SuperBetEvent).length;
    const bankersSuperBetEventsCount = this.bankerTicketItemGroups.filter(g => g.mappingType === EventMappingType.SuperBetEvent).length;
    if (systemSuperBetEventsCount + bankersSuperBetEventsCount < 1) {
      return true;
    }

    const bankersEventsNonSbCount = this.bankerTicketItemGroups.filter(g => g.mappingType !== EventMappingType.SuperBetEvent).length;

    if (bankersEventsNonSbCount >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS) {
      return true;
    }

    if (eventsInCombination >= ConstantValues.SUPER_BET_REQUIRED_NONE_SB_TICKETITEMS - bankersEventsNonSbCount + systemSuperBetEventsCount) {
      return true;
    }

    return false;

  }

  // private calculateRegularSystemOptions() {
  //   const groupList = Object.entries(this.ticketItemGroups).map(([k, v]) => v);
  //   for (let i = 0; i < this.orderingForTicketItemGroups.length; i++) {
  //     if (this.isMultiplaySystem) {
  //       this.systemOptions.push({
  //         eventsInCombination: i + 1,
  //         maxOdds: 0,
  //         minOdds: 0,
  //         numberOfCombinations: this.calcNumOfCombination(groupList, i + 1),
  //         optionSelected: false, totalNumberOfEvents: this.orderingForTicketItemGroups.length,
  //         isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1),
  //         oddsForNumberOfHits: {}
  //       });
  //     }
  //     else {
  //       this.systemOptions.push({
  //         eventsInCombination: i + 1,
  //         maxOdds: 0,
  //         minOdds: 0,
  //         numberOfCombinations: Math.round(Combinatorics.C(this.orderingForTicketItemGroups.length, i + 1)),
  //         optionSelected: false,
  //         totalNumberOfEvents: this.orderingForTicketItemGroups.length,
  //         isSuperBetConditionFulfilled: this.isSystemOptionSuperBetConditionFulfilled(i + 1),
  //         oddsForNumberOfHits: {}
  //       });
  //     }
  //   }
  // }

  // private calcNumOfCombination(ticketItemGroups: ITicketItemGroup[], k: number): number {
  //   let retVal = 0;
  //   const tempArray: number[] = [];
  //   const combinationsEvent = Combinatorics.combination<ITicketItemGroup>(ticketItemGroups, k);
  //   let singleCombo: ITicketItemGroup[] = [];
  //   // tslint:disable-next-line:no-conditional-assignment
  //   while (singleCombo = combinationsEvent.next()) {
  //     let temp = 1;
  //     singleCombo.forEach(gr => {
  //       temp *= Object.keys(gr.ticketItems).length;
  //     });
  //     tempArray.push(temp);
  //   }

  //   retVal = tempArray.reduce((pv, cv) => pv + cv, 0);
  //   return retVal;
  // }

  showHideSystemOptions() {
    this.showSystemOptions = !this.showSystemOptions;
  }

  protected createTicket(): ITicket {
    return this.ticketService.createSystemTicket(this.bankerTicketItemGroups, this.systemTicketItemGroups, this.isMultiplayBanker, this.isMultiplaySystem, this.systemOptions, this.ticketData.freeBetValue, this.freeBetService.playerFreeBetSettings, this.ticketData);
  }

  protected openTicketConfirm() {
    this.ticketService.openTicketConfirmation(this.oddsValidationMode,
      this.ticketData,
      this.systemOptions.findIndex((so) => so.optionSelected && so.eventsInCombination < this.systemTicketItemGroups.length) < 0,
      this.isMultiplayBanker,
      this.isMultiplaySystem,
      this.systemOptions,
      this.placeBetType);
  }

  protected calculateFreeBet() {
    const freebets = this.ticketService.calculateFreeBet(this.freeBetService.playerFreeBetSettings,
      this.freeBetBalance,
      this.ticketData.numberOfBets,
      this.orderingForTicketItemGroups,
      this.wagerPerBet,
      this.ticketData.totalOdd,
      this.ticketData.totalWinings,
      this.ticketData.bonus,
      this.ticketData.totalStake);

    this.ticketData.freeBetValue = freebets.freeBetValue;
    this.ticketData.freeBetValueToShow = freebets.freeBetValueToShow;
  }
}

